import { useContext, useMemo } from 'react'

import EntitiesSelector from './EntitiesSelector'
import { GlobalContext } from '../../../Providers/GlobalProvider'
import { useSelector } from 'react-redux'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { isNonEmptyArray } from '../../../utils'

const CountriesSelector = ({ countries, className = '', disabled, multiple = 'default', reverse = false, style = {}, values, dropdownRender, onChange }) => {
  const gc = useContext(GlobalContext)

  const t = useSelector(selectTranslate)

  const countriesOptions = useMemo(() => {
    const entities = isNonEmptyArray(countries) ? countries : gc.countries

    return entities.map(country => ({
      label: t('country.' + country.code),
      value: country.id,
      tooltip: t('country.' + country.code),
      entity: country
    }))
  }, [countries, gc?.countries, t])

  return (
    <EntitiesSelector
      className={className}
      disabled={disabled}
      entityOptions={countriesOptions}
      multiple={multiple}
      showSearch
      style={style}
      values={values}
      onChange={onChange}
    />
  )
}

export default CountriesSelector
